import { render } from "./NotifiedStyle.vue?vue&type=template&id=702a2e95"
import script from "./NotifiedStyle.vue?vue&type=script&lang=js"
export * from "./NotifiedStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__